import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Link, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';

import { useAppSettings } from 'contexts/AppSettingsContext';
import ActionSlugs, { IfUserIsAllowed } from 'services/PermissionsService';
import MDAvatar from 'components/atoms/MDAvatar/MDAvatar';
import { Sizes } from 'models/StyleModels';
import UserMenu from 'components/organisms/UserMenu/UserMenu';
import Logo from 'assets/images/logo/JointAi2025Logo.png';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { Breakpoints } from 'models/StyleModels';
import { DesktopActionsBox, DesktopTitle, LogoImage, MobileTitle, StyledAppBar, StyledHomeButton, TabsRegion, MobileTabsRegion } from './TriageListAppBar.styles';

interface TriageListAppBarProps {
    demoFlow?: boolean | undefined;
    tabList?: React.ReactNode;
}

const TriageListAppBar: React.FC<TriageListAppBarProps> = ({ demoFlow = false, tabList }) => {
    const { homeRoute } = useAppSettings();
    const [searchParams] = useSearchParams();
    const { breakpointBreached: mdBreakpointBreached } = useBreakpoints({ breakpoint: Breakpoints.MEDIUM });

    const { VIEW$TRIAGE_LIST_PAGE } = ActionSlugs;

    return (
        <StyledAppBar>
            <div>
                <Toolbar disableGutters>
                    <DesktopTitle variant="h5" noWrap>
                        <Link to={demoFlow ? { pathname: '/demo/exam-room', search: `?patientName=${searchParams.get('patientName')}` } : homeRoute}>
                            <LogoImage src={Logo} alt="Joint AI Logo" />
                        </Link>
                    </DesktopTitle>

                    {/* Desktop tabs - only show when not mobile */}
                    {!mdBreakpointBreached && <TabsRegion>{tabList}</TabsRegion>}

                    <MobileTitle variant="h5" noWrap>
                        <IfUserIsAllowed to={VIEW$TRIAGE_LIST_PAGE}>
                            <Link to={demoFlow ? { pathname: '/demo/exam-room', search: `?patientName=${searchParams.get('patientName')}` } : homeRoute}>
                                <LogoImage src={Logo} alt="Joint AI Logo" />
                            </Link>
                        </IfUserIsAllowed>
                    </MobileTitle>

                    <DesktopActionsBox>
                        <IfUserIsAllowed to={VIEW$TRIAGE_LIST_PAGE}>
                            <Link to={demoFlow ? { pathname: '/demo/exam-room', search: `?patientName=${searchParams.get('patientName')}` } : homeRoute}>
                                <StyledHomeButton variant='contained' key="Dashboard" color="secondary">
                                    <FontAwesomeIcon icon={faHouse} />
                                </StyledHomeButton>
                            </Link>
                        </IfUserIsAllowed>
                    </DesktopActionsBox>

                    {demoFlow ? (
                        <IconButton onClick={() => { }} sx={{ p: 0 }}>
                            <MDAvatar src={''} size={Sizes.X_LARGE} alt="Avatar" />
                        </IconButton>
                    ) : (
                        <UserMenu />
                    )}
                </Toolbar>

                {/* Mobile tabs - only show when mobile, positioned below toolbar */}
                {mdBreakpointBreached && tabList && (
                    <MobileTabsRegion>
                        {tabList}
                    </MobileTabsRegion>
                )}
            </div>
        </StyledAppBar>
    );
};

export default TriageListAppBar; 